import type { IGlobalDialogContent } from "~/types/components/layout-dialog.type";

export const useLayoutDialog = () => {
    // * global dialog states
    const showGlobalDialog = useState<boolean>("showGlobalDialog", () => false);

    const globalDialogContent = useState<IGlobalDialogContent>("globalDialogComponent", () => {
        return {} as IGlobalDialogContent;
    });

    const closeable = useState("makeDialogCloseable", () => true);

    const openDialog = (content: IGlobalDialogContent) => {
        showGlobalDialog.value = true;
        globalDialogContent.value = content;
    };
    const editDialogContent = (title: string) => {
        globalDialogContent.value.title = title;
    };
    return {
        // * states
        showGlobalDialog,
        globalDialogContent,
        closeable,

        // * methods
        openDialog,
        editDialogContent
    };
};
